<template>
  <router-view/>

  <!-- Quick Translation Editor (Alt+T) -->
  <app-translation-quick-edit />

  <notifications
      group="foo-css"
      position="top left"
      :speed="500"
  />

  <!-- Custom style example -->
  <notifications
      group="custom-style"
      position="top left"
      classes="n-light"
      :max="3"
      :width="400"
  />

  <!-- Custom template example -->
  <notifications
      group="custom-template"
      :duration="8000"
      :width="this.layoutStore.isDesktop ? 500 : '90%'"
      :position="this.layoutStore.isDesktop ? 'top left' : 'bottom center'"
  >
    <template #body="{ item }">
      <q-card dark style="margin-top:70px;z-index:9999">
        <div class="custom-template-title">
          {{ item.title }}
          <q-btn
              round
              flat
              dense
              icon="close"
              class="float-right"
              color="grey-8"
              @click="close(item.id)"
          ></q-btn>
        </div>
        <q-card-section>
          <q-item v-if="item.type==='information'" class="custom-template-content-information">
            <q-item-section avatar>
              <q-icon color="white" size="md" name="info"/>
            </q-item-section>
            <q-item-section>
              <div
                  v-html="item.text"
              />
            </q-item-section>

          </q-item>
          <q-item v-else-if="item.type==='warning'" class="custom-template-content-warning">
            <q-item-section avatar>
              <q-icon color="orange" size="md" name="warning"/>
            </q-item-section>
            <q-item-section>
              <div
                  v-html="item.text"
              />
            </q-item-section>

          </q-item>
          <q-item v-else-if="item.type==='error'" class="custom-template-content-error">
            <q-item-section avatar>
              <q-icon color="red" size="md" name="error"/>
            </q-item-section>
            <q-item-section>
              <div
                  v-html="item.text"
              />
            </q-item-section>

          </q-item>
        </q-card-section>

      </q-card>
    </template>
  </notifications>


</template>

<script>
import {defineComponent} from 'vue';
import EventBus from '@core/services/utils/appEventBusService'
import {useLayoutStore} from '@core/stores/layoutStore';
import {useAppMenuStore} from '@core/stores/app/appMenuStore';
import appNavigationService from '@core/services/utils/appNavigationService';
import aiaUiCommandService from '@aia-services/aia/aiaUiCommandService';
import {mapStores} from "pinia";
import AppTranslationQuickEdit from "@app-components/translation/appTranslationQuickEdit.vue";

export default defineComponent({
  name: 'App',
  components: {
    AppTranslationQuickEdit
  },
  inject: ["notify"],
  data() {
    return {
      id: 0
    };
  },
  methods: {
    close(id) {
      this.notify.close(id)
    },
    show(options) {
      const group = options.group
      const title = options.title
      const text = options.message
      const type = options.type
      this.notify({
        group,
        title: title,
        text,
        type,
        data: {
          randomNumber: Math.random(),
        },
        close: true,
        ignoreDuplicates: true

      });
    },

    clean(group) {
      this.notify({group, clean: true});
    },

    /**
     * Handle the `openUser` UI command — backend resolved the AppUser id;
     * the front just pushes to the user-detail route.
     */
    handleOpenUserCommand(params) {
      if (!params?.userId) {
        this.notifyMissingHandler('openUser', params, 'userId manquant');
        return;
      }
      const pushPromise = appNavigationService.push({
        name: 'app-user-detail',
        params: { userId: params.userId },
      });
      if (pushPromise?.catch) {
        pushPromise.catch((e) => this.notifyMissingHandler('openUser', params,
          `push échoué : ${e?.message || e}`));
      }
    },

    /**
     * Handle the `navigate` UI command emitted by C'lia. The backend
     * already resolved `menuKey` against AppMenu + translations; the front
     * only has to look up the route and push.
     */
    handleNavigateCommand(params) {
      const menuKey = params?.menuKey;
      if (!menuKey) {
        this.notifyMissingHandler('navigate', params, 'menuKey manquant');
        return;
      }
      const item = this.appMenuStore?.retrieveItem(menuKey);
      if (!item) {
        this.notifyMissingHandler('navigate', params,
          `menuKey ${menuKey} introuvable dans le store (menu pas encore chargé ?)`);
        return;
      }
      const target = item.name ? { name: item.name } : item.goTo;
      if (!target) {
        this.notifyMissingHandler('navigate', params,
          `menu ${menuKey} trouvé mais sans route ni goTo`);
        return;
      }
      const pushPromise = appNavigationService.push(target);
      if (pushPromise?.catch) {
        pushPromise.catch((e) => this.notifyMissingHandler('navigate', params,
          `push échoué : ${e?.message || e}`));
      }
    },

    notifyMissingHandler(action, params, reason) {
      EventBus.emit('notify', {
        group: 'foo-css',
        type: 'warn',
        title: 'C\'lia',
        message: `Action « ${action} »${params?.query ? ' (' + params.query + ')' : (params?.target ? ' (' + params.target + ')' : '')} non exécutée${reason ? ' : ' + reason : ''}.`
      });
    }
  },
  computed: {
    ...mapStores(useLayoutStore, useAppMenuStore),
  },
  created() {
    EventBus.on('notify', (notification) => {
      this.show(notification)
    })
    aiaUiCommandService.register('navigate', (params) => this.handleNavigateCommand(params));
    aiaUiCommandService.register('openUser', (params) => this.handleOpenUserCommand(params));
    aiaUiCommandService.setFallback((action, params, reason) => this.notifyMissingHandler(action, params, reason));
  }
});
</script>

<style lang="scss">


.custom-template-content-information {
  vertical-align: center;
  text-wrap: auto;
  margin-top: auto;
  margin-bottom: auto;
  color: white;
  font-size: 18px;

}

.custom-template-content-warning{
  vertical-align: center;
  text-wrap: auto;
  margin-top: auto;
  margin-bottom: auto;
  color: orange;
  font-size: 18px;

}

.custom-template-content-error {
  vertical-align: center;
  margin-top: auto;
  text-wrap: auto;
  margin-bottom: auto;
  color: red;
  font-size: 18px;

}


.custom-template-title {
  text-transform: uppercase;
  font-size: 18px;
  padding-left: 10px;
  color: #31CCEC;
}

</style>
